// extracted by mini-css-extract-plugin
module.exports = {"container":"_43fe77e","detailContainer":"_de2023b","detail":"_75386a7","label":"_bd60051","value":"_8855192"};